var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLocationIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.824,
    height: 22.559,
    viewBox: "0 0 16.824 22.559",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_48552",
    "data-name": "Group 48552",
    transform: "translate(-513.7 -5892.95)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_47969",
    "data-name": "Group 47969",
    transform: "translate(514 5893.25)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_47968",
    "data-name": "Group 47968",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "pin",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_47967",
    "data-name": "Group 47967"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_47966",
    "data-name": "Group 47966"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_728",
    "data-name": "Path 728",
    d: "M56.192,0A8.121,8.121,0,0,0,48.08,8.112a9.359,9.359,0,0,0,.688,3.123,13.082,13.082,0,0,0,.938,1.754l5.562,8.427a1.058,1.058,0,0,0,1.849,0l5.562-8.428a13.026,13.026,0,0,0,.938-1.754A9.357,9.357,0,0,0,64.3,8.112,8.121,8.121,0,0,0,56.192,0Zm6.544,10.865a11.988,11.988,0,0,1-.855,1.6l-5.562,8.428c-.11.167-.145.167-.254,0L50.5,12.463a11.992,11.992,0,0,1-.855-1.6,8.5,8.5,0,0,1-.614-2.752,7.157,7.157,0,0,1,14.315,0A8.5,8.5,0,0,1,62.736,10.865Z",
    transform: "translate(-48.08)",
    fill: "#0538bc",
    stroke: "#0538bc",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_729",
    "data-name": "Path 729",
    d: "M116.374,64.008a4.294,4.294,0,1,0,4.294,4.294A4.3,4.3,0,0,0,116.374,64.008Zm0,7.635a3.34,3.34,0,1,1,3.34-3.34A3.344,3.344,0,0,1,116.374,71.643Z",
    transform: "translate(-108.263 -60.19)",
    fill: "#0538bc",
    stroke: "#0538bc",
    strokeWidth: 0.6
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationIcon);
export default __webpack_public_path__ + "static/media/location-icon.f2c79332dbb92f9fc586047ea0920426.svg";
export { ForwardRef as ReactComponent };